module.exports = __webpack_public_path__ + "img/pic-05.c0dd97cc.png";